import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useFlavour } from '../context/FlavourContext';
import { useLang } from '../context/LanguageContext';

// Dynamic flavour CTA: TRY {FLAVOUR} →
export default function FlavourCTA({ onClick, className = '', solid = true, flavourId }) {
  const { flavour } = useFlavour();
  const { t } = useLang();
  const f = flavourId ? null : flavour;
  const color = f ? f.primary : '#ff2d2d';
  const name = f ? f.name : '';

  const base = 'inline-flex items-center gap-2 px-6 py-3.5 rounded-lg font-cond tracking-wide text-base md:text-lg transition-all group flavour-transition';

  if (solid) {
    return (
      <button onClick={onClick} className={`${base} text-black hover:brightness-110 ${className}`} style={{ background: color, boxShadow: `0 10px 40px -12px ${color}` }}>
        {t('tryPrefix')} {name}
        <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
      </button>
    );
  }
  return (
    <button onClick={onClick} className={`${base} border text-white hover:bg-white/5 ${className}`} style={{ borderColor: color, color }}>
      {t('tryPrefix')} {name}
      <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
    </button>
  );
}
